<template>
  <b-row>
    <b-col cols="12">
      <button-group-description />
      <button-group-basic />
      <button-group-size />
      <button-group-dropdown-support />
      <button-toolbar-navigation />
      <button-toolbar-input />
      <button-toolbar-dropdown />
      <button-toolbar-size />
      <button-toolbar-justify />
    </b-col>
  </b-row>
</template>

<script>
import { BRow, BCol } from 'bootstrap-vue'
import ButtonGroupDescription from './ButtonGroupDescription.vue'
import ButtonGroupBasic from './ButtonGroupBasic.vue'
import ButtonGroupSize from './ButtonGroupSize.vue'
import ButtonGroupDropdownSupport from './ButtonGroupDropdownSupport.vue'
import ButtonToolbarNavigation from '../button-toolbar/ButtonToolbarNavigation.vue'
import ButtonToolbarInput from '../button-toolbar/ButtonToolbarInput.vue'
import ButtonToolbarDropdown from '../button-toolbar/ButtonToolbarDropdown.vue'
import ButtonToolbarSize from '../button-toolbar/ButtonToolbarSize.vue'
import ButtonToolbarJustify from '../button-toolbar/ButtonToolbarJustify.vue'

export default {
  components: {
    BRow,
    BCol,

    ButtonGroupDescription,
    ButtonGroupBasic,
    ButtonGroupSize,
    ButtonGroupDropdownSupport,
    ButtonToolbarNavigation,
    ButtonToolbarInput,
    ButtonToolbarDropdown,
    ButtonToolbarSize,
    ButtonToolbarJustify,
  },
}
</script>
